export const API_FULL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
//# sourceMappingURL=date.js.map